import { render, staticRenderFns } from "./BaseAccessory.vue?vue&type=template&id=3ff871db&"
import script from "./BaseAccessory.vue?vue&type=script&lang=js&"
export * from "./BaseAccessory.vue?vue&type=script&lang=js&"
import style0 from "./BaseAccessory.vue?vue&type=style&index=0&id=3ff871db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports